// extracted by mini-css-extract-plugin
export default {"section":"ReservationSection_section__t3pDx","overlay":"ReservationSection_overlay__6EY+q","content":"ReservationSection_content__KPipH"};